import React from 'react';
import {BrowserRouter, Routes} from 'react-router-dom';
import Provider from '../../context/Provider';
import {ReactChildren} from '../../types/types';

interface IProvider {
  children: ReactChildren;
}

const AppWrapper = ({children}: IProvider): React.ReactElement => {
  return (
    <Provider>
      <BrowserRouter>
        <Routes>{children}</Routes>
      </BrowserRouter>
    </Provider>
  );
};

export default AppWrapper;
